import { compose } from 'ramda'
import { withProps } from 'recompose'
import withTheme from 'modules/hoc/withTheme'
import display from 'modules/hoc/display'
import theme from './theme.scss'

const generateHashCode = text => {
  let hash = 0
  let i = 0
  let chr = 0
  if (text.length === 0) return hash
  for (i = 0; i < text.length; i += 1) {
    chr = text.charCodeAt(i)
    hash = (hash << 5) - hash + chr // eslint-disable-line no-bitwise
    hash |= 0 // eslint-disable-line no-bitwise
  }
  return hash
}

const withAriaTags = withProps(({ title, svg }) => ({
  ariaTags: title
    ? { labelledBy: `${svg}${generateHashCode(title)}`, hidden: null }
    : { labelledBy: null, hidden: true },
}))

export default compose(
  display,
  withTheme(theme),
  withAriaTags
)
